module.exports = __webpack_public_path__ + "a7595b1d769a562510331d359a09152a.fbx";